/**
 * Матрица QR → SVG-путь (приглашение по ссылке, аудит удобства 2026-10-04).
 *
 * <p>Один путь из тёмных модулей вместо сотен `<Rect>`: так дешевле и на телефоне, и в вебе.
 * Поле вокруг кода — часть стандарта: без него камера теряет код на фоне.
 */
export const QR_QUIET_ZONE = 4;

export function qrPath(matrix: Uint8Array): { size: number; d: string } {
  const size = Math.round(Math.sqrt(matrix.length));
  let d = '';
  for (let y = 0; y < size; y++) {
    for (let x = 0; x < size; x++) {
      if (matrix[y * size + x]) d += `M${x + QR_QUIET_ZONE} ${y + QR_QUIET_ZONE}h1v1h-1z`;
    }
  }
  return { size, d };
}
